import { getCountFromServer, query, where } from 'firebase/firestore'
import type {
  MutationRequestFilter,
  MutationRequestStatus,
} from '~/features/MutationRequests/mutationRequestsModel'
import type { Identifiable } from '~/models/identifiable'
import { PullService } from './servicePull'

export class MutationRequestsCountService extends PullService<
  Identifiable,
  Identifiable[]
> {
  private collection

  constructor() {
    super()
    const { collection } = useFirebase()
    this.collection = collection
  }

  public async getCountByStatus(
    status: MutationRequestStatus,
    filter: MutationRequestFilter,
  ): Promise<number> {
    const collection = this.collection('MedicationAgreementMutationRequests')

    const filterAction
      = filter === 'all' ? ['update', 'delay', 'stop'] : [filter]

    const countQuery = query(
      collection,
      where('Status', '==', status),
      where('RequestAction', 'in', filterAction),
    )

    const snapshot = await getCountFromServer(countQuery)
    return snapshot.data().count
  }
}
